export function UPDATE_USER_INFO(state, data) {
  state.userInfo = data;
}

export function SET_LABELLIST(state, data) {
  state.labelList = data
}
export function REMOVE_LABEL(state, data) {
  const index = state.labelList.findIndex((item) => item.routerName === data);
  state.labelList.splice(index, 1);
}

export function SET_OPEN_KEYS(state, data) {
  state.openKeys = data;
}

export function SET_SELECTED_KEYS(state, data) {
  state.selectedKeys = data;
}

export function SET_COLLAPSED(state, data) {
  state.collapsed = data;
}
export function SET_MENULIST(state, data) {
  state.menuList = data;
}

// 设置语言
export function SET_LOCALE(state, data) {
  state.locale = data
}

export function CLEAR_VUEX(state) {
  state.userInfo = null; // 用户信息
  state.labelList = []; // 页签数据
  state.menuList = [];
  state.openKeys = []; // 展开菜单
  state.selectedKeys = []; // 选中菜单
}
